import { State } from '@/stores/enquiries/state';
import { Actions } from '@/stores/enquiries/actions';
import { Getters } from '@/stores/enquiries/getters';
import { Mutations } from '@/stores/enquiries/mutations';
import { Module } from 'vuex';

export class EnquiryStore implements Module<State, any> {
    public namespaced: boolean = true;
    public state: State = new State();
    public actions: Actions = new Actions();
    public getters: Getters = new Getters();
    public mutations: Mutations = new Mutations();
}
